import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function Banner({ total = 3, intervalMs = 60000, fadeDuration = 2000 }) {
  const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * total));
  const [nextIndex, setNextIndex] = useState(null);
  const [fading, setFading] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const currentImageRef = useRef(null);

  // Get dimensions of the first image to maintain consistent layout
  useEffect(() => {
    const img = new Image();
    img.src = `/banners/hypr${currentIndex + 1}.png`;
    img.onload = () => {
      setDimensions({ width: img.width, height: img.height });
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const next = pickRandomIndex(currentIndex, total);
      setNextIndex(next);
      setFading(true);

      setTimeout(() => {
        setCurrentIndex(next);
        setNextIndex(null);
        setFading(false);
      }, fadeDuration);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [currentIndex, total, intervalMs, fadeDuration]);

  const currentSrc = `/banners/hypr${currentIndex + 1}.png`;
  const nextSrc = nextIndex !== null ? `/banners/hypr${nextIndex + 1}.png` : null;
  
  // Create a style with appropriate transition duration in ms
  const transitionStyle = {
    transitionDuration: `${fadeDuration}ms`,
  };

  return (
    <div className="relative w-full text-center my-4 overflow-hidden">
      <Link to="/">
        <div 
          className="relative inline-block" 
          style={{ 
            width: dimensions.width || 'auto', 
            height: dimensions.height || 'auto' 
          }}
        >
          {/* Current image that fades out */}
          <img
            ref={currentImageRef}
            src={currentSrc}
            alt="Hypr banner"
            className={`mx-auto max-w-full h-auto rounded shadow transition-opacity absolute top-0 left-0 ${
              fading ? 'opacity-0' : 'opacity-100'
            }`}
            style={transitionStyle}
          />
          
          {/* Next image that stays beneath */}
          <img
            src={nextSrc || currentSrc}
            alt="Hypr banner"
            className="mx-auto max-w-full h-auto rounded shadow"
          />
        </div>
      </Link>
    </div>
  );
}

function pickRandomIndex(exclude, total) {
  let next;
  do {
    next = Math.floor(Math.random() * total);
  } while (next === exclude && total > 1);
  return next;
}
